<template>
    <div class="left_wrap">
        <!-- Date Filter -->
        <DateFilter />
        <div class="schedule_wrap">
            <div class="schedule_scroll">
                <!-- Code Filter  -->
                <CodeFilter />
                <!-- Schedule Calendar -->
                <ScheduleCalendar ref="ScheduleCalendar"/>
            </div>
        </div>
    </div>
</template>


<script>
import DateFilter from './DateFilter/DateFilter.vue'
import CodeFilter from './CodeFilter/CodeFilter.vue'
import ScheduleCalendar from './ScheduleCalendar/ScheduleCalendar.vue'

export default {
    components: {
        DateFilter,
        CodeFilter,
        ScheduleCalendar
    },
}
</script>